import React, {Component, ReactNode} from 'react'
import {ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import {ColumnFlexContainer} from '../../styledComponents/FlexComponents'
import {Box} from '@mui/material'
import {CompleteMessage} from '../reservations/components/CommonStyle'
import styled from 'styled-components'
import {withPageTitle} from '../shared/hoc/withPageTitle'

interface Props {
    status: 'complete' | 'cancel' | 'error'
}

class AccountTransferApplyResultPage extends Component<Props & ResidentPagePropsSet> {

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
    }

    getIcon(): ReactNode {
        let icon: ReactNode
        switch (this.props.status) {
            case 'complete' :
                icon = <img src={'/resources/images/icons/icon_reserve_complete.svg'} alt={'complete'}/>
                break
            case 'cancel' :
            case 'error' :
                icon = <img src={'/resources/images/icons/icon_error.svg'} alt={'error'}/>
                break
        }
        return icon
    }

    getTitleMessage(): string {
        let message: string
        switch (this.props.status) {
            case 'complete' :
                message = 'お手続きが完了しました'
                break
            case 'cancel' :
                message = 'お手続きが中止されました'
                break
            case 'error' :
                message = 'エラーが発生しました'
                break
        }
        return message
    }

    getDetailMessage(): string {
        let message: string
        switch (this.props.status) {
            case 'complete' :
                message = 'このページを閉じてください'
                break
            case 'cancel':
            case 'error':
                message = 'このページを閉じて、やり直してください'
                break
        }
        return message
    }

    render(): ReactNode {
        const icon = this.getIcon()
        const titleMessage = this.getTitleMessage()
        const detailMessage = this.getDetailMessage()
        return <>
            <ComponentArea>
                <Box flexGrow={1}/>
                <ColumnFlexContainer>
                    {icon}
                    <Box height={'30px'}/>
                    <CompleteMessage>
                        {titleMessage}
                    </CompleteMessage>
                    <Box height={'10px'}/>
                    <div>
                        {detailMessage}
                    </div>
                </ColumnFlexContainer>
                <Box flexGrow={2}/>
            </ComponentArea>
        </>
    }
}

const ComponentArea = styled(ColumnFlexContainer)`
  height: 100%;
`

export default withPageTitle(AccountTransferApplyResultPage)
